import { render } from "./hotelReservation.vue?vue&type=template&id=3c75b0a6"
import script from "./hotelReservation.vue?vue&type=script&lang=js"
export * from "./hotelReservation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__